'use client';

import { StateFrom } from 'xstate';
import { createWordleMachine } from '@wordle/game-engine';

type WordleState = StateFrom<ReturnType<typeof createWordleMachine>>;

interface WordleDebugPanelProps {
  state: WordleState;
}

export function WordleDebugPanel({ state }: WordleDebugPanelProps) {
  const { context, value } = state;
  const typedContext = context as unknown as {
    currentRow: number;
    cursorCol: number;
    targetWord: string;
    grid: { letter: string | null; state: string }[][];
  };

  return (
    <div className="fixed bottom-4 right-4 w-[360px] max-h-[70vh] overflow-auto rounded-lg bg-black/80 text-green-300 text-xs font-mono p-4 shadow-xl">
      <h2 className="text-green-400 font-bold mb-2">
        🐞 Wordle Debug
      </h2>

      <section className="mb-3">
        <div className="text-green-500">targetWord</div>
        <pre>{typedContext.targetWord || '(empty)'}</pre>
      </section>

      <section className="mb-3">
        <div className="text-green-500">state.value</div>
        <pre>{JSON.stringify(value, null, 2)}</pre>
      </section>

      <section className="mb-3">
        <div className="text-green-500">cursor</div>
        <pre>{JSON.stringify({ row: typedContext.currentRow, col: typedContext.cursorCol }, null, 2)}</pre>
      </section>

      <section className="mb-3">
        <div className="text-green-500">grid</div>
        <pre>
          {typedContext.grid
            .map(row =>
              row
                .map(tile => tile.letter ?? '_')
                .join(' ')
            )
            .join('\n')}
        </pre>
      </section>
      <section>
        <div className="text-green-500">raw context</div>
        <pre>{JSON.stringify(context, null, 2)}</pre>
      </section>
    </div>
  );
}
